import { AxiosRequestConfig } from "axios";
import { fetchData } from "@/utils";

import { ApiError, AudienceSegment, Variable } from "@/types";

type ExportApiResponse = {
  data: { audience_id: string; url: string };
  error: ApiError | null;
};

export const exportAudience = async (
  accessToken: string,
  audienceId: string,
  audienceName: string,
  audienceType: string,
  audienceGeo: string,
  exportMode: string,
  variables: Variable[],
  summarize: boolean,
  segment: AudienceSegment,
): Promise<ExportApiResponse> => {
  const params = new URLSearchParams({
    audience_id: audienceId,
    audience_name: audienceName,
    audience_type: audienceType,
    audience_geo: audienceGeo,
    export_mode: exportMode,
  });
  if (segment.segment_id > 0)
    params.append("segment", String(segment.segment_name));
  if (variables.length > 0)
    params.append("variables", variables.map((x) => x.tag_id).join(","));
  if (summarize) params.append("summarize", "true");

  let url = `${process.env.REACT_APP_API_URL}/export?${params.toString()}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};
